import React, { useContext, useEffect, useRef, useState } from 'react';
import { PngImages, SvgImages } from "../../Utils/LocalImages"
import SessionManager from '../../Utils/Session';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../Context/authContext';
import RoutesPath from '../../Utils/RoutesPath';
import Image from '../../Components/Reusable/Image';
import SubmitButtonTwo from '../../Components/Reusable/Buttontwo';
import StudentDashboardServices from '../../Services/StudentDashboardApiService';
import { handleApiErrors } from '../../Utils/Utils';
import ApiConstants from '../../Utils/ApiConstant';
import { useSidebar } from '../../Context/toggleContext';

let cartCount = ""
const StudentNavbar = () => {
  const navigate = useNavigate();
  const [packageData, setPackagesData] = useState([])
  const { user } = useContext(AuthContext)
  const { toggleSidebar } = useSidebar()
  const isBharatSatExam = location.pathname.match(
    new RegExp(`^${RoutesPath.bharatSatTest}/[a-f0-9]{24}`)
  );
  // useEffect(() => {
  //   console.log(cart, 'cart');
  // }, [cart])

  const [activeDropdown, setActiveDropdown] = useState(null);
  const cartdropdownRef = useRef(null);
  const logindropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (cartdropdownRef.current && !cartdropdownRef.current.contains(event.target) &&
        logindropdownRef.current && !logindropdownRef.current.contains(event.target)) {
        setActiveDropdown(null);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const toggleCartDropdown = (event) => {
    getAllCart()
    event.stopPropagation();
    setActiveDropdown(activeDropdown === 'cart' ? null : 'cart');
  };

  const toggleLoginDropdown = (event) => {
    event.stopPropagation();
    setActiveDropdown(activeDropdown === 'login' ? null : 'login');
  };

  const handleclosemodal = () => {
    setActiveDropdown(false);

  };
  const handleLogout = async () => {
    try{
      const response = await StudentDashboardServices.logoutDevices(SessionManager.shared.getSessionToken());
    
      setActiveDropdown(false);  
    }
   catch(error){
    handleApiErrors(error);
    
   }

  };

  const getAllCart = async () => {
    try {
      const response = await StudentDashboardServices.getAllCart();
      setPackagesData(response.cartList || []);
      cartCount = response.cartCount
      updateUserCartCount(cartCount);

    } catch (error) {
      handleApiErrors(error);
    }
  };
  // useEffect(() => {
  //   getAllCart()
  // }, [])
  const truncateText = (text, charLimit) => {
    if (!text) return "";
    return text.length > charLimit ? text.substring(0, charLimit) + "..." : text;
  };
  return (
    <nav className="topnavbar d-flex align-items-center justify-content-between">
      <button
        className="navbar-toggler-co"
        onClick={toggleSidebar}
      >
        ☰
      </button>
      <h4 className="blue mb-0 sub-large-text-one fw-600 Responsivetextwel">{`Welcome, ${user?.firstName?.trim()}!`}</h4>
      <div className="right-admin-profile d-flex align-items-center" style={{ paddingRight: '30px' }}>
        {
          !isBharatSatExam && (
            <div className="d-flex align-items-center gap-4" >
              <div className='Button-navbar ms-auto position-relative cartmodalstyle' ref={cartdropdownRef}>
                <Image src={SvgImages.addtocart} alt="Add to Cart" className="cursor-pointer" onClick={toggleCartDropdown} />
                {user.cartCount > 0 && (
                  <span className="translate-middle badge rounded-pill " style={{ backgroundColor: '#14489F' }}>
                    {user.cartCount}
                  </span>
                )}
                <div className={` dropdown-menu modalcart selectSection  ${activeDropdown === 'cart' ? "show" : ""}`} aria-labelledby="dropdownMenuLink" data-popper-placement="bottom-end">
                  <div className='d-flex flex-column gap-3 p-0'>
                    <div className='col-md-12'>
                      {packageData.slice(0, 3).map(item => (
                        <div key={item.package_id} className="cart-item row align-items-center m-0 hrline mt-2 pb-2">
                          <div className='col-md-4 col-sm-4 p-0 col-xs-4 addtocardimagesizepopup'>
                            <Image className="card-img-top addtocartimage" src={item?.mainImage && item.mainImage?.trim() !== "" ? ApiConstants.FILE_FETCH_URL + item.mainImage : ""} alt='' />

                          </div>
                          <div className='col-md-8 col-sm-8  col-xs-8 justify-content-between d-flex  text-start '>
                            <div className='w-100 py-2 '>
                              <div className='medium-text fw-700 text-dark py-2 ' title={item.packageName}>{truncateText(item.packageName, 40)}</div>
                              {/* <p>Price: ₹{item.price}</p> */}
                              <div className="d-flex gap-2">
                                <span className="disprice sub-large-text  fw-700">₹{item.discountedPrice}</span>
                                <div className="originalprice small-text fw-400 pb-1">₹{item.actualPrice}</div>
                              </div>
                            </div>

                          </div>

                        </div>
                      ))}
                    </div>
                    {
                      cartCount > 0 ?
                        <div className='text-center '>
                          <Link to={RoutesPath.addtocart}><h3 className='small-medium-text fw-700 orangeAccentColor mb-0'>View Cart</h3></Link>
                        </div> :
                        <div className='text-center '>
                          <h3 className='small-medium-text fw-700 orangeAccentColor mb-0'>Cart is Empty...</h3>
                        </div>
                    }

                  </div>

                </div>
              </div>
              <div>
                <a href="#" className="">
                  <Image src={SvgImages.student_notification} alt="Notification" />
                </a>
              </div>

              <div className='Button-navbar ms-auto position-relative' ref={logindropdownRef}>

                <Image src={SvgImages.powerbutton} alt="Notification" className="cursor-pointer" onClick={toggleLoginDropdown} />

                <div className={`dropdown-menu modalregistered selectSection  ${activeDropdown === 'login' ? "show" : ""}`} aria-labelledby="dropdownMenuLink" data-popper-placement="bottom-end">
                  <div className='d-flex gap-3 align-items-center'>
                    <div className='d-flex flex-column gap-3'>
                      <h2 className='small-medium-text black text-center mb-0 fw-600'>Are you Sure you want to logout?</h2>
                      <div className='d-flex gap-2 justify-content-center'>
                        <Link to={RoutesPath.home}>
                          <SubmitButtonTwo title={"Yes"} className="yesbutton cursor-pointer" onclick={handleLogout} />
                        </Link>
                        <Link to={RoutesPath.dashboardstudent}>
                          <SubmitButtonTwo title={"No"} className="nobutton cursor-pointer" onclick={handleclosemodal} />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          )
        }

      </div>
    </nav>
  );
};

export default StudentNavbar;
